import React from "react";
import { Link } from "gatsby";

import "./covid-info-banner.scss";

const CovidInfoBanner = ({ onClick }) => {
  return (
    <div className="covid-banner">
      <Link to="/informacje-o-covid-19" className="covid-banner__text">
        Informacje dotyczące COVID-19
      </Link>
      <button className="covid-banner__btn" type="button" onClick={onClick} />
    </div>
  );
};

export default CovidInfoBanner;
